import React from "react";

import "./spacer.css";

class Spacer extends React.Component {
  render() {
    return <div className="contentBlock spacer" />;
  }
}
export default Spacer;
